import { render, staticRenderFns } from "./ThirdPartyList.vue?vue&type=template&id=be19b4fc"
import script from "./ThirdPartyList.vue?vue&type=script&lang=ts"
export * from "./ThirdPartyList.vue?vue&type=script&lang=ts"
import style0 from "./ThirdPartyList.vue?vue&type=style&index=0&id=be19b4fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports